<template>
  <Layout>
    <Navbar/>
    <Header class="sub-header" style="margin-top:64px;">
      <div class="container">
        <div class="sub-header-items left">
          <h3>Webcast List</h3>
        </div>
        <div class="sub-header-items right">
          <Select v-model="selected" style="width:150px;" @on-change="webcastListChange()">
            <Option value="all">All</Option>
            <Option value="upcoming">Upcoming</Option>
            <Option value="live">Live</Option>
            <Option value="ended">Completed</Option>
          </Select>
          <router-link to="new-webcast" class="ivu-btn ivu-btn-primary">New Webcast</router-link>
        </div>
      </div>
    </Header>
    <Content>
      <div class="container" style="margin-bottom:40px;">
          <div class="list-group webcast-list">
            <div class="list-group-item" v-for="wc in wcList" :key="wc._id" >
              <router-link :to="'wc/'+wc._id+'/settings'">
              <h4 class="list-group-item-heading">{{wc.title}}</h4>
              <Tag color="default" v-if="wc.status=='ended'" style="float:right;">Ended</Tag>
              <Tag color="primary" v-if="wc.status=='upcoming'" style="float:right;">Upcoming</Tag>
              <Tag color="error" v-if="wc.status=='live'" style="float:right;">Live</Tag>
              <p class="list-group-item-text">
                Start: {{wc.startAt | moment("DD.MM.YYYY @HH:mm")}}
              </p>

              </router-link>
            </div>
          </div>
          <Divider/>
          <Page :current="page.current" :total="page.total" simple @on-change="changePage"></Page>
      </div>
    </Content>
  </Layout>
</div>
</template>

<script>
import feathersClient from '@/api/feathers-client'
import Navbar from '@/components/base/Navbar.vue'
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      wcList: [],
      selected: 'all',
      page: {}
    }
  },
  components: {
    Navbar
  },
  computed:{
  },
  methods: {
    ...mapActions('webcast', {
      findWebcastAction: 'find',
    }),
    webcastListChange(){
      let query = {};
      if(this.selected!='all'){
        query['status'] = this.selected
      }
      this.getWebcastList(query,1);
    },
    changePage(page){
      this.getWebcastList({}, page);
    },
    getWebcastList(query, page){
      query['accountId'] =  this.$store.state.account.copy._id,
      query['$sort'] =  {startAt: -1};
      query['$skip'] =  (page-1)*10;
      feathersClient.services.webcast.find({query: query}).then((response)=>{
        if (response.data) {
          this.$set(this.$data, 'wcList', response.data);

          let skip = response.skip+1
          let page = Math.round(skip / response.limit)+1

          this.$set(this.$data, 'page', {
            current: page,
            total: response.total
          });
        }
      })
    }
  },
  created() {
    //console.log(this.$store.state.auth.user);
    this.getWebcastList({}, 1);
  },
  mounted() {

  }
}
</script>

<style>
.wc-list-filter-wrapper{
  width:150px;
  float: left;
}
.wc-list-new-btn-wrapper{
  float: right;
}
.wc-list-title{
  width: 300px;
  margin: auto;
}

</style>
